<template>
    <div class="bg-white rounded-md shadow print:shadow-none p-6 mb-4 print:-mb-8 print:-mt-5">
        <p v-if="summary.id && isMobileEligible && isMobileInterested" class="print:m-0 font-bold">You’ve successfully completed your Internet order. Create an account above to:</p>
        <ol v-if="isMobileEligible && isMobileInterested" class="font-thin list-decimal list-inside pl-1 py-0.5">
            <li class="py-0.5">Finish your Breezeline Mobile order</li>
            <li class="py-0.5">Activate AutoPay & EcoSave to get up to a $10 monthly discount</li>
        </ol>
        <div v-else>
          <h3 class="text-xl mb-6">
            You're almost there!
          </h3>
          <p class="font-bold mb-6">
            You’ve successfully completed your order but you still need to sign up for AutoPay & EcoSave to receive up to a $10 monthly discount.
          </p>
          <p class="mb-6">
            You can set up AutoPay & EcoSave by creating a My Breezeline account after your installation. <a href="https://create.my.breezeline.com/Create" target="_blank">Click HERE</a> if you’d like to visit and bookmark the registration page.
          </p>
        </div>
        <p class="font-bold"><span v-if="!isMobileInterested || !isMobileEligible">You will need your account number handy to complete your activation.<br/></span>Your account number is <span class="text-salmon" data-cy="account-number">{{ summary.id && summary.id.replace(/#/g, '') }}</span></p>

        <p class="mt-8 print:hidden">To save this order confirmation, please print or save this page as a PDF by clicking on the “Print a Receipt” button below.</p>

        <p class="print:hidden pt-1">
            <button
                @click="print()"
                class="text-sm font-bold flex items-center">
                <IconPrint class="mr-1 flex-shrink-0" />
                Print a Receipt
            </button>
        </p>
    </div>
</template>

<script>
import IconPrint from "@/atoms/icons/IconPrint"
import { mapState } from 'vuex'
export default {
    name: "AccountInfo",
    components: {
        IconPrint,
    },
    computed: {
        ...mapState({
			mobileInterested: state => state.Buyflow.mobileInterested,
        }),
    },
    props: {
        summary: {
            type: Object,
            required: true,
        },
		isMobileEligible: {
			type: Boolean,
            required: true,
		},
		isMobileInterested: {
			type: Boolean,
			required: true,
		},
    },
    watch: {
        mobileInterested: {
            immediate: true,
            handler(value) {
                this.mobileInterestedSendEvent();
            }
        }
    },
    methods: {
        mobileInterestedSendEvent() {
            if (this.mobileInterested) {
                gtag('event', 'mobile_interest_bzlsale');
            }
        },
        print(){
            window.print()
        }
    },
}
</script>
